// 비공식·제휴 참고 링크. 배너 광고 금지. 비어 있으면 UI가 공식 표 우선 안내.
// 넣을 때는 공식에 가까운 교재·시험 안내만, 학원 세일 URL 금지.
export const adjacentRefs = [
  // 예:
  // {
  //   id: 'example',
  //   label: '표시명',
  //   why: '왜 보나 (한 줄)',
  //   url: 'https://…',
  //   note: '비공식·참고. 요강·공고 원문이 우선.',
  // },
];
